import { Directive, Input, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { GoogleTagManagerService } from '../services/gtm';

@Directive({
  selector: '[libGtmTrackClick]'
})
export class GtmTrackClickDirective {
  @Input() libGtmTrackClick!: string;
  @Input() gtmAction?: string;
  @Input() gtmCategory?: string;

  constructor(
    private gtmService: GoogleTagManagerService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const element = this.libGtmTrackClick || (event.target as HTMLElement).tagName.toLowerCase();
    const action = this.gtmAction || 'click';
    const category = this.gtmCategory || 'interaction';

    this.gtmService.trackClick(element, action, category);
  }
}

